import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

export type ClassFilterOption = {
  id: number | string;
  name: string;
};

type ClassFilterSelectProps = {
  classes?: ClassFilterOption[];
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  allLabel?: string;
  allValue?: string;
  includeAllOption?: boolean;
  triggerClassName?: string;
};

const ClassFilterSelect = ({
  classes = [],
  value,
  onChange,
  placeholder,
  allLabel,
  allValue = 'all',
  includeAllOption = true,
  triggerClassName = 'w-[200px]',
}: ClassFilterSelectProps) => {
  const resolvedAllLabel = allLabel ?? placeholder;

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={triggerClassName}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {includeAllOption && (
          <SelectItem value={allValue}>{resolvedAllLabel}</SelectItem>
        )}
        {classes.map((classInfo) => (
          <SelectItem key={classInfo.id} value={classInfo.id.toString()}>
            {classInfo.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default ClassFilterSelect;
